module.exports = __webpack_public_path__ + "public/SiteIcons/verifiedIcon.svg?4d14c1a6";